import React from "react";
import { isEmpty } from "lodash";
// components
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
import MNPGV2 from "./MNPGV2";
import BottomShape01 from "@/components/shapes/BottomShape01";
import ParasuitShape01 from "@/components/shapes/ParasuitShape01";
import LeftShape01 from "@/components/shapes/LeftShape01";
import BookShape01 from "@/components/shapes/BookShape01";
import PencilShape02 from "@/components/shapes/PencilShape02";
import BeeShape01 from "@/components/shapes/BeeShape01";
import RightShape01 from "@/components/shapes/RightShape01";
import StarShape01 from "@/components/shapes/StarShape01";
import HeroShape01 from "@/components/shapes/HeroShape01";
import RMDRImage from "@/components/RMDRImage";
// types
import { TMainPageLayoutV2 } from "../type";
// utilities
import { 
    mainPageItemNameDescriptionLanguageVersion,
    outerTextLanguageVersion
} from "@/utilities/LanguageVersionSelectorShortcut";
// enums
import EResourceType from "@/cms/enums/EResourceType";


const MNPG020 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG020.rendered", props);

    if ( !props.template || isEmpty(props.template) ) return null;

    const languageVersion = mainPageItemNameDescriptionLanguageVersion(props.template?.languageVersions);
    const description = outerTextLanguageVersion(props.template?.languageVersions, "find", "DESCRIPTION");

    return (
        <section className="hero-section hero-1 fix">
            <BottomShape01 />
            <ParasuitShape01 className="float-bob-y" />
            <LeftShape01 />
            <BookShape01 className="float-bob-x" />
            <PencilShape02 />
            <BeeShape01 className="float-bob-y" />
            <RightShape01 />
            <StarShape01 />
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6">
                        <div className="hero-content">
                            <h5 >
                                {languageVersion?.name}
                            </h5>
                            <RMDRComponentSanitizer 
                                languageVersion={languageVersion}
                                valueExpr="value"
                                variant="h1"
                                extraData={{"data-aos-duration":"800", "data-aos":"fade-up", "data-aos-delay":"300"}} 
                                removeTag 
                            />
                            <RMDRComponentSanitizer 
                                languageVersion={description}
                                valueExpr="value"
                                variant="p"
                                extraData={{"data-aos-duration":"800", "data-aos":"fade-up", "data-aos-delay":"500"}} 
                                removeTag 
                            />
                            <MNPGV2 templates={props.templates} mapLayoutName={props.template?.mapLayoutName} parentId={props.template?.id} allowedComponent={["MNPG_065"]} />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div
                            className="hero-image"
                            data-aos-duration="800"
                            data-aos="fade-up"
                            data-aos-delay="400"
                        >
                            <RMDRImage 
                                title={languageVersion?.name}
                                alt={languageVersion?.name}
                                resources={props.template.resources}
                                resourceType={EResourceType.OUTER_IMAGE}
                            />
                            <HeroShape01 />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

const Component = React.memo(MNPG020, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    console.log("MNPG020.memo", { prevProps, nextProps });
    return true;
});

export default Component;
